import {
    cleanCommonParams,
    mapContentParams,
    mapImageParams,
    mapSalesChannelsParams,
    mapStatesParams,
    mapPlatformsParams,
    mapProductsParams,
} from './common';

const mapVideoParams = (isCreate, video) => {
    if (!video) return null;
    return {
        id: video.id,
        url: video.url,
        duration: video.duration,
        _destroy: video._destroy,
    };
};

const mapBannerParams = (
    isCreate,
    {
        content,
        image,
        video,
        sales_channels,
        states,
        state_ids,
        sales_channel_ids,
        platforms,
        products,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            banner: {
                ...cleanCommonParams(params),
                ...mapContentParams(isCreate, content),
                ...mapImageParams(isCreate, image),
                video_attributes: mapVideoParams(isCreate, video),
                ...mapSalesChannelsParams(isCreate, sales_channels || sales_channel_ids),
                ...mapStatesParams(isCreate, states || state_ids),
                ...mapPlatformsParams(isCreate, platforms),
                ...mapProductsParams(isCreate, products),
            },
        });
    });
};

export { mapBannerParams };
